import { useCallback } from 'react';

import { fetchQuery, graphql } from 'react-relay';

import { useRelayEnvironmentProvider } from '@atlassian/relay-environment-provider';

import { useProductDependencies } from '../use-product-dependencies';

import type { useGetSpaceIdFromSpaceKeyQuery } from './__generated__/useGetSpaceIdFromSpaceKeyQuery.graphql';

export const useGetSpaceIdsFromSpaceKeys = (): ((spaceKeys: string[]) => Promise<string[]>) => {
	const { submitError } = useProductDependencies();
	const environment = useRelayEnvironmentProvider().getEnvironment({});

	return useCallback(
		async (spaceKeys: string[]): Promise<string[]> => {
			if (spaceKeys.length === 0) {
				return [];
			}

			try {
				const data = await fetchQuery<useGetSpaceIdFromSpaceKeyQuery>(
					environment,
					graphql`
						query useGetSpaceIdFromSpaceKeyQuery($spaceKeys: [String]) {
							spaces(spaceKeys: $spaceKeys) {
								nodes {
									id
								}
							}
						}
					`,
					{ spaceKeys },
				).toPromise();

				const spaceIds: string[] = (data?.spaces?.nodes ?? [])
					.map((node) => node?.id ?? '')
					.filter((id: string): id is string => !!id);

				return spaceIds;
			} catch (error) {
				submitError?.(error as Error);
			}

			return [];
		},
		[submitError, environment],
	);
};
